import React from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
const SalaryRequests = () => {
  const TableData = [
    {
      date: "Jan 04, 2022	",
      title: "salary",
      description: "Lorem ipsum dolor sit a...",
      salaryMonth: "Jan 04, 2022",
      amount: "$2,000",
      status: "Paid",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      description: "Lorem ipsum dolor sit a...",
      salaryMonth: "Jan 04, 2022",
      amount: "$2,000",
      status: "Unpaid",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      description: "Lorem ipsum dolor sit a...",
      salaryMonth: "Jan 04, 2022",
      amount: "$2,000",
      status: "Paid",
    },

    {
      date: "Jan 04, 2022	",
      title: "salary",
      description: "Lorem ipsum dolor sit a...",
      salaryMonth: "Jan 04, 2022",
      amount: "$2,000",
      status: "Paid",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      description: "Lorem ipsum dolor sit a...",
      salaryMonth: "Jan 04, 2022",
      amount: "$2,000",
      status: "Paid",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      description: "Lorem ipsum dolor sit a...",
      salaryMonth: "Jan 04, 2022",
      amount: "$2,000",
      status: "Paid",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      description: "Lorem ipsum dolor sit a...",
      salaryMonth: "Jan 04, 2022",
      amount: "$2,000",
      status: "Paid",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      description: "Lorem ipsum dolor sit a...",
      salaryMonth: "Jan 04, 2022",
      amount: "$2,000",
      status: "Paid",
    },
  ];
  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={10} lg={10} md={10} sm={8} xs={8}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={4}>
              <Button className="header-button" variant="text">
                <p className="page-header-button-text">Download</p>
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Search by Teachers Name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by title"
                />
              </div>
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-header">
            <p className="table-heading">salary requests</p>
          </div>
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="salary-request-table-id-heading">ID</th>
                <th className="salary-request-table-date-heading">Date</th>
                <th className="salary-request-table-teacher-name-heading">
                  Teachers Name
                </th>
                <th className="salary-request-table-title-heading">Title</th>
                <th className="salary-request-table-description-heading">
                  Discription
                </th>
                <th className="salary-request-table-salary-month-heading">
                  Salary Month
                </th>
                <th className="salary-request-table-amount-heading">amount</th>
                <th className="salary-request-table-status-heading"></th>
                <th className="salary-request-table-generate-heading"></th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-id-data">{tableIndex + 1}</td>
                    <td className="table-data">{tableValue.date}</td>
                    <td className="table-data">Willow Anderson</td>
                    <td className="table-data">{tableValue.title}</td>
                    <td className="table-data">{tableValue.description}</td>
                    <td className="table-data">{tableValue.salaryMonth}</td>
                    <td className="table-center-data">{tableValue.amount}</td>
                    <td className="table-data">
                      <div
                        className="student-panel-leave-table-status"
                        style={{
                          backgroundColor:
                            tableValue.status === "Paid"
                              ? "#D2FFEB"
                              : "#FFB0B0",
                          color:
                            tableValue.status === "Paid"
                              ? "#098B51"
                              : "#B80000",
                        }}
                      >
                        {tableValue.status}
                      </div>
                    </td>

                    <td className="table-data">
                      <Button className="salary-request-table-generate-receipt-button">
                        Make Payment
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default SalaryRequests;
